import EnumDataSource from "../utils/enum-data-source.util";

export const CHART_NOTES_LIMIT = 25;

export const CHART_NOTES_GENERAL_TYPE = 1;
export const CHART_NOTES_VISIT_TYPE = 2;
export const CHART_NOTES_BILLING_TYPE = 3;
const chartNoteTypes = {
  [CHART_NOTES_GENERAL_TYPE]: "General Note",
  [CHART_NOTES_VISIT_TYPE]: "Patient Visit",
  [CHART_NOTES_BILLING_TYPE]: "Billing Note"
};

export const PATIENT_VISIT_TYPE = "Patient Visit";

export const CHART_NOTE_TYPES = new EnumDataSource(chartNoteTypes);

export const CHART_NOTE_DRAFT = 1;
export const CHART_NOTE_COMPLETED = 2;
export const chartNoteStatus = {
  [CHART_NOTE_DRAFT]: "Draft",
  [CHART_NOTE_COMPLETED]: "Completed"
};

export const CHART_NOTE_STATUS = new EnumDataSource(chartNoteStatus);
export const CHART_NOTE_APPOINTMENT_COMPLETION_STATUS = new EnumDataSource({
  "0": "No Chart Note",
  ...chartNoteStatus
});
